export enum RoutesEnum {
  Root = '/',
  Welcome = '/welcome',
  Discover = '/discover',
  Organizations = '/organizations',
  Assessments = '/assessments',
  Agree = '/agree',
  Report = '/report',
}